import { DiagnosisActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  diagnosisCodesList: null,
  postDiagnosisCodeData: null,
  getDiagnosisCodeById: null,
  deleteDiagnosisCode: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {

  case DiagnosisActionTypes.get_diagnosis_codes.REQUEST:
    return {
      ...state,
      loading: true,
      diagnosisCodesList: null,
    };
  case DiagnosisActionTypes.post_diagnosis_code.REQUEST:
    return {
      ...state,
      loading: true,
      postDiagnosisCodeData: null,
    };
  case DiagnosisActionTypes.get_diagnosis_code_by_id.REQUEST:
    return {
      ...state,
      loading: true,
      getDiagnosisCodeById: null,
    };
  case DiagnosisActionTypes.get_diagnosis_code_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      getDiagnosisCodeById: payload,
    };
  case DiagnosisActionTypes.delete_diagnosis_code.REQUEST:
    return {
      ...state,
      loading: true,
      deleteDiagnosisCode: null,
    };
  case DiagnosisActionTypes.get_diagnosis_codes.SUCCESS:
    return {
      ...state,
      diagnosisCodesList: payload,
      loading: false,
    };
  case DiagnosisActionTypes.post_diagnosis_code.SUCCESS:
    return {
      ...state,
      postDiagnosisCodeData: payload,
      loading: false,
    };
  case DiagnosisActionTypes.delete_diagnosis_code.SUCCESS:
    return {
      ...state,
      deleteDiagnosisCode: payload,
      loading: false,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/diagnosisCode/reducers/DiagnosisReducer.js